module.exports = __webpack_public_path__ + "static/media/test3.b3f89a0c.jpg";